<style lang="less" scoped>
.query-title-div {
  width: 150px !important;
}

.fade-leave,
// 离开前,进入后透明度是1
.fade-enter-to {
  opacity: 1;
}

.fade-leave-active,
.fade-enter-active {
  transition: all 0.5s; //过度是2秒
}

.fade-leave-to,
.fade-enter {
  opacity: 0;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">充电桩基础信息管理</div>

      <div class="page-action-btns flex" style="margin:10px 0">
        <button class="common-bg-button" @click="listAddFun()">新 增</button>
        <button class="common-bg-button" @click="listEditFun()">编 辑</button>
        <button class="common-bg-button" @click="toHandelRecord()">修改日志</button>
        <div class="flex-1"></div>

        <button class="common-empty-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="getListData(pagination, true)">
          搜 索
        </button>
        <button class="common-bg-button" @click="seniorSerch()">高级筛选</button>
      </div>
      <transition name="fade">
        <ZD-list-querys v-show="isShow">
          <template slot="inputs">
            <div class="list-query-child-div flex">
              <div class="query-title-div">充电桩显示名称</div>
              <div class="query-inputs-div flex-1">
                <el-input size="small" class="fuul-width" v-model="queryInfo.showName" placeholder="请输入内容"
                  clearable></el-input>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">充电桩型号</div>
              <div class="query-inputs-div flex-1">
                <el-input size="small" v-model="queryInfo.pileTypeName" placeholder="请输入内容" clearable></el-input>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">成品料号</div>
              <div class="query-inputs-div flex-1">
                <el-input size="small" v-model="queryInfo.materialNo" placeholder="请输入内容" clearable></el-input>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">业务归属</div>
              <div class="query-inputs-div flex-1">
                <el-select class="full-width" size="small" v-model="queryInfo.businessBelong" clearable
                  placeholder="请选择">
                  <el-option label="电商" value="01"></el-option>
                  <el-option label="非电商" value="02"></el-option>
                </el-select>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">充电桩类型</div>
              <div class="query-inputs-div flex-1">
                <el-select class="full-width" size="small" v-model="queryInfo.chargingPileType" clearable
                  placeholder="请选择">
                  <el-option label="壁挂式" value="WALL_MOUNTED"></el-option>
                  <el-option label="便携式" value="PORTABLE"></el-option>
                  <el-option label="五菱桩" value="WULING"></el-option>
                </el-select>
              </div>
            </div>
          </template>
        </ZD-list-querys>
      </transition>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>
    <!-- 操作日志 -->
    <el-dialog title="操作日志" width="60%" :visible.sync="handelRecordObj.showDialog">
      <el-table class="el-table" :data="handelRecordObj.tableData" border max-height="600px"
        style="width: 100%;margin:20px auto"
        :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
        <el-table-column prop="lastModifiedByName" width="80" label="操作人">
        </el-table-column>
        <el-table-column prop="lastModifiedWhen" width="160" label="更改时间">
        </el-table-column>
        <el-table-column prop="data" min-width="300" label="更改数据">
        </el-table-column>
      </el-table>
      <div class="list-pagination">
        <ZD-pagination :pagination="handelRecordObj.pagination" v-on:pageUpdate="toHandelRecord"></ZD-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.pwdResetObj.formInfo.restPassWord) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      isShow: false,
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //页码
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      }, // 列操作按钮
      statueArr: [], //角色状态下拉框
      pwdResetObj: {
        showDialog: false,
        formInfo: {},
        rules: {
          restPassWord: [
            {
              required: true,
              message: "请输入新密码",
              trigger: "blur",
            },
          ],
          checknewPassWord: [
            {
              required: true,
              validator: validatePass,
              trigger: "blur",
            },
          ],
        },
      },
      handelRecordObj: {
        showDialog: false,
        tableData: [],
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
        },
      },
      userPhone: "", //用户手机号码
      userName: "", //用户姓名
    };
  },
  methods: {
    //执行表格数据函数 角色状态下拉框
    init() {
      this.getListData(this.pagination, true);
      this.getConfig();
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.digitization.pileFunctionPage, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    seniorSerch() {
      this.isShow = !this.isShow
    },

    //角色状态下拉框
    getConfig() {
      let _ = this;
      _.$H.post(_, _.$A.config.list, { configType: "192" }).then((res) => {
        _.statueArr = res.data.data;
      });
    },
    // 页面新增方法
    listAddFun() {
      this.$S.listAddFun(this, pageConfig.tableEditObj);
    },
    checkSelectOne() {
      if (this.selections.length < 1) {
        this.$U.error('请选择需要操作的对象');
        return false;
      }
      if (this.selections.length > 1) {
        this.$U.error('只能选择一个操作的对象');
        return false;
      }
      return true;
    },
    // 页面编辑方法
    listEditFun() {
      let _ = this;
      if (this.checkSelectOne()) {
        _.$store.commit('setEditId', _.selections[0].id)
        _.$router.push({
          name: 'ChargingPileDetail',
          query: {
            pileTypeNo: this.selections[0].pileTypeNo
          }
        })
      }
    },
    toHandelRecord() {
      let _ = this;
      let obj = {
        pageNum: _.handelRecordObj.pagination.current - 1,
        pageSize: _.handelRecordObj.pagination.pageSize,
        webType: 'pileType'
      }
      _.$H.post(_, _.$A.digitization.webLog, obj).then(res => {
        _.handelRecordObj.tableData = res.data.data.content || [];
        _.handelRecordObj.pagination.total = res.data.data.totalElements || 0;
        _.handelRecordObj.showDialog = true;
      })
    },
    //重置按钮
    reset() {
      this.pagination.current = 1;
      this.queryInfo = {};
      this.getListData(this.pagination);
    },
    //密码修改
    toResetPwd() {
      this.userPhone = "";
      this.userName = "";
      this.pwdResetObj.formInfo = {};
      if (this.selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
      } else if (this.selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
      } else {
        this.pwdResetObj.showDialog = true;
        this.userPhone = this.selections[0].userPhone;
        this.userName = this.selections[0].userName;
        this.pwdResetObj.formInfo.userId = this.selections[0].userId;
      }
    },
    //密码提交
    submitPwdFrom(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            restPassWord: _.pwdResetObj.formInfo.restPassWord,
            userId: _.pwdResetObj.formInfo.userId,
          };
          _.$H.post(_, _.$A.user.userPwdReset, obj).then((res) => {
            _.$U.success("修改成功");
            _.pwdResetObj.showDialog = false;
          });
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
